import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { API_URL } from "../config";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    fetch(`${API_URL}/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(r => setState(r.ok ? "ok" : "error"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <section style={{ maxWidth: 480, textAlign: "center", margin: "40px auto" }}>
      {state === "loading" && (
        <>
          <Loader2 size={40} className="spin" color="#007c84" />
          <p style={{ color: "#888", marginTop: 12 }}>Подтверждаем email…</p>
        </>
      )}
      {state === "ok" && (
        <>
          <CheckCircle2 size={44} color="#15803d" />
          <h2 style={{ color: "#15803d", marginTop: 12 }}>Email подтверждён</h2>
          <p style={{ color: "#666" }}>Теперь вы можете писать в чат. Спасибо!</p>
          <Link to="/" className="header-auth-btn" style={{ background: "#007c84", color: "#fff", display: "inline-block", marginTop: 10 }}>
            На главную
          </Link>
        </>
      )}
      {state === "error" && (
        <>
          <XCircle size={44} color="#c0392b" />
          <h2 style={{ color: "#c0392b", marginTop: 12 }}>Ссылка недействительна</h2>
          <p style={{ color: "#666" }}>
            Возможно, она устарела или уже была использована. Запросите новую ссылку в разделе «Мой профиль».
          </p>
          <Link to="/profile" className="header-auth-btn" style={{ background: "#007c84", color: "#fff", display: "inline-block", marginTop: 10 }}>
            В профиль
          </Link>
        </>
      )}
    </section>
  );
}
